<div class="bp-card surface">
  <button class="bp-edit" type="button" (click)="openEditDialog()" title="Edit">
    <span class="material-symbols-outlined">edit</span>
  </button>
  <div class="bp-title">{{ partner.CompanyName }}</div>
  <div class="bp-detail">
    <strong>{{ 'business_partner_card.name' | translate }}</strong>
    {{ partner.Name }}
  </div>
  <div class="bp-detail">
    <strong>{{ 'business_partner_card.last_name' | translate }}</strong>
    {{ partner.LastName }}
  </div>
  <div class="bp-detail">
    <strong>{{ 'business_partner_card.phone' | translate }}</strong>
    {{ partner.Phone }}
  </div>
  <div class="bp-detail">
    <strong>{{ 'business_partner_card.email' | translate }}</strong>
    {{ partner.Email }}
  </div>
  <div class="bp-detail">
    <strong>{{ 'business_partner_card.level' | translate }}</strong>
    {{ partner.Level }}
  </div>
  <div class="bp-detail">
    <strong>{{ 'business_partner_card.created_by' | translate }}</strong>
    {{ partner.CreatedBy }}
  </div>
  <div class="bp-detail bp-switch-container">
    <strong>{{ 'business_partner_card.copilot_enabled' | translate }}</strong>
    <label class="switch">
      <input type="checkbox" [checked]="partner.Enabled" (change)="toggleEnabled()" [disabled]="updating" />
      <span class="slider"></span>
    </label>
  </div>
  <div class="bp-detail">
    <strong>{{ 'business_partner_card.created_date' | translate }}</strong>
    {{ partner.CreatedDate | localizedDate }}
  </div>

  <app-add-business-partner-dialog *ngIf="showEditDialog"
    [submitting]="submittingEdit"
    [mode]="'edit'"
    [initialPartner]="partner"
    (closed)="closeEditDialog()"
    (submitPartner)="onSubmitEdit($event)">
  </app-add-business-partner-dialog>
</div>
